import { getBaseHost } from 'components/hmilib/hmiglobal';
import { rootStore } from 'store';
import { ErrorResponse } from '../../interfaces';

export const fetchData = <T extends object | FormData | undefined>(
    url: string,
    method: 'GET' | 'POST',
    body?: T,
    customOptions?: RequestInit
): Promise<any | ErrorResponse> => {
    const host = getBaseHost();

    const defaultHeaders: Record<string, string> = {
        Authorization: `Bearer ${rootStore.AuthStore.token}`,
        Accept: 'application/json',
        ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json' })
    };

    const headers: HeadersInit = customOptions?.headers ?? defaultHeaders;

    const options: RequestInit = {
        method,
        headers,
        ...customOptions
    };

    if (body && !(body instanceof FormData)) {
        options.body = JSON.stringify(body);
    } else if (body instanceof FormData) {
        options.body = body;
    }

    return fetch(`${host}${url}`, options)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        })
        .catch((error) => {
            console.error('error', error);
            throw error;
        });
};
